import { MdVerified, MdStar, MdLocationOn, MdSchedule } from 'react-icons/md';
import { t } from '../../utils/i18n';
import { LANDING_AVATARS } from './constants';

export default function HeroPreviewCard() {
  const stats = [
    { key: 'hoursLogged' },
    { key: 'shifts' },
    { key: 'paymentReady' },
  ];

  return (
    <div className="landing-hero-preview-wrap w-full max-w-[400px] mx-auto lg:mx-0 lg:ml-auto">
      <article className="landing-hero-preview rounded-2xl p-5 sm:p-6">
        <p className="text-xs font-medium uppercase tracking-wider text-[var(--color-text-muted)] mb-4">
          {t('landing.preview.cardTitle')}
        </p>

        <div className="flex items-center gap-3.5">
          <img
            src={LANDING_AVATARS.jovana}
            alt=""
            className="w-14 h-14 rounded-full object-cover flex-shrink-0 border border-[var(--color-border)]"
            loading="lazy"
            referrerPolicy="no-referrer"
          />
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="text-base font-semibold text-[var(--color-text)]">
                {t('landing.preview.name')}
              </h3>
              <span className="inline-flex items-center gap-0.5 text-sm font-medium text-[var(--color-text)]">
                <MdStar className="text-amber-500 text-sm" aria-hidden="true" />
                4.9
              </span>
            </div>
            <p className="flex items-center gap-1 text-sm text-[var(--color-text-muted)] mt-0.5">
              <MdLocationOn className="text-[15px] flex-shrink-0 opacity-70" aria-hidden="true" />
              {t('landing.preview.location')}
            </p>
          </div>
        </div>

        <div className="mt-4 flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium landing-preview-verified">
            <MdVerified className="text-sm" aria-hidden="true" />
            {t('landing.preview.verified')}
          </span>
          <span className="text-xs text-[var(--color-text-muted)]">
            {t('landing.preview.availability')}
          </span>
        </div>

        <div className="mt-5 grid grid-cols-3 gap-2">
          {stats.map(({ key }) => (
            <div
              key={key}
              className="landing-preview-stat rounded-xl px-2.5 py-2.5 text-center"
            >
              <p className="text-xs font-medium text-[var(--color-text)] leading-snug">
                {t(`landing.preview.${key}`)}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-4 flex items-center gap-2 px-3 py-2.5 rounded-xl landing-preview-schedule text-sm text-[var(--color-text-muted)]">
          <MdSchedule className="text-base flex-shrink-0 opacity-70" aria-hidden="true" />
          <span>{t('landing.preview.schedule')}</span>
        </div>
      </article>
    </div>
  );
}
